import {
  registerFormInputComponent,
  addNavMenuItem,
  registerBulkAction,
  registerCustomDetailComponent,
} from "@bb-vendure/admin-ui/core";
import { ShippingSettingDropdownComponent } from "./components/shipping-setting-dropdown/shipping-setting-dropdown.component";
import { deleteBulkAction } from "./components/bulkAction";
import { SplitOrderInfoComponent } from "./components/split-order-info/split-order-info.component";
import { SplitOrderRuleSelectComponent } from "./components/split-order-select/select.component";
import { deleteBulkActionShippingFeeZone } from "./components/bulkActionShippingFeeCountry";

export default [
  registerFormInputComponent(
    "split-order-rule-select",
    SplitOrderRuleSelectComponent
  ),
  registerBulkAction(deleteBulkAction),
  registerCustomDetailComponent({
    locationId: "order-detail",
    component: SplitOrderInfoComponent,
  }),
  registerFormInputComponent(
    "shipping-setting-dropdown",
    ShippingSettingDropdownComponent
  ),
  registerBulkAction(deleteBulkAction),

  registerBulkAction(deleteBulkActionShippingFeeZone),
  addNavMenuItem(
    {
      id: "split-order-rules",
      label: "nav.shipping-rules",
      routerLink: ["/extensions/split-order-rules"],
      icon: "calculator",
      requiresPermission: (userPermissions) => {
        return userPermissions.includes("ReadSplitOrderRule");
      },
    },
    "shipping-section"
  ),
  // addNavMenuItem(
  //   {
  //     id: "shipping-fee",
  //     label: "shippingFee.shipping-fee",
  //     routerLink: ["/extensions/shipping-fee"],
  //     icon: "calculator",
  //     requiresPermission: (userPermissions) => {
  //       return userPermissions.includes("ReadShippingFee");
  //     },
  //   },
  //   "shipping-section"
  // ),
];
